import { Card, List, Tag, Empty } from 'antd';
import type { DashboardWidget } from '@/api/dashboardApi';

interface ActivityItem {
  id: string;
  subject: string;
  type: string;
  status: string;
  scheduled_at: string | null;
}

interface ActivityFeedWidgetProps {
  widget: DashboardWidget;
  data?: ActivityItem[];
  loading?: boolean;
}

const TYPE_COLORS: Record<string, string> = {
  call: 'blue',
  email: 'cyan',
  meeting: 'purple',
  note: 'default',
  task: 'orange',
};

export default function ActivityFeedWidget({ widget, data, loading }: ActivityFeedWidgetProps) {
  if (!data || data.length === 0) {
    return (
      <Card title={widget.title} size="small" loading={loading} style={{ height: '100%' }}>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      </Card>
    );
  }

  return (
    <Card title={widget.title} size="small" loading={loading} style={{ height: '100%' }}>
      <List
        size="small"
        dataSource={data}
        renderItem={(item) => (
          <List.Item>
            <List.Item.Meta
              title={
                <span>
                  <Tag color={TYPE_COLORS[item.type] ?? 'default'}>{item.type}</Tag>
                  {item.subject}
                </span>
              }
              description={
                item.scheduled_at
                  ? new Date(item.scheduled_at).toLocaleString()
                  : undefined
              }
            />
            <Tag>{item.status}</Tag>
          </List.Item>
        )}
      />
    </Card>
  );
}
